// extracted by mini-css-extract-plugin
module.exports =  {"labels":"da51a739f7--labels--g8BuG","labels__item":"da51a739f7--labels__item--y2IhO"};